import type { LensCardAlignment } from '~/types/leLens';

/**
 * Metrics use the same centred default as compact KPI cards. A saved editor
 * choice remains authoritative, including for older persisted cards.
 */
export function resolveMetricAlignment(alignment: unknown): LensCardAlignment {
  return alignment === 'center' || alignment === 'right' || alignment === 'left' ? alignment : 'center';
}
